import React, { Fragment } from 'react'
import { components } from 'react-select'

const { ValueContainer, Placeholder } = components

export default function CustomValueContainer1({ children, ...props }) {
    const renderSelectedCount = (selectedValues) => {
        return (
            selectedValues?.length ? <div className="selected-value" style={{ padding: "5px 10px", fontSize: "13px" }}>
                {`${selectedValues.length} ${selectedValues.length === 1 ? "" : ""} selected`}
            </div> : ""
        )
    }

    const renderPlaceholder = (placeholderText) => {
        return {
            __html: placeholderText
        }
    }

    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {(props.hasValue || props.selectProps.menuIsOpen) ? (
                    <>
                        <div
                            dangerouslySetInnerHTML={renderPlaceholder(props.selectProps.placeholder || '')}
                            className='backgroundDiminsh'
                        />
                        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            {props.getValue().length > 0 ? (
                                <div>
                                    {renderSelectedCount(props.getValue())}
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </>
                ) : (
                    <div
                        dangerouslySetInnerHTML={renderPlaceholder(props.selectProps.placeholder || '')}
                    />
                )}
            </Placeholder>

            {React.Children.map(children, (child) => {
                return (
                    <Fragment>{child && child.key !== 'placeholder' ? child : null}</Fragment>
                )
            })}
        </ValueContainer>
    )
}
